import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M12.9715 2.30485C13.6742 1.60216 14.7703 1.60216 15.473 2.30485C16.1757 3.00754 16.1757 4.10368 15.473 4.80637L6.5841 13.6953C6.44273 13.8366 6.26605 13.978 6.03879 14.079C5.80767 14.1817 5.57039 14.2223 5.33333 14.2223C5.09628 14.2223 4.859 14.1817 4.62788 14.079C4.40062 13.978 4.22394 13.8366 4.08257 13.6953L0.527016 10.1397C-0.175672 9.43702 -0.175672 8.34087 0.527016 7.63818C1.2297 6.93549 2.32585 6.93549 3.02854 7.63818L5.33333 9.94298L12.9715 2.30485Z" />,
  'CheckResponsive',
);
